export default "__VITE_ASSET__977c435e__"